export default __webpack_public_path__ + "84cd39f9d5a56f4ad6d61fdebf53192e.png";